





import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {ActiveProvide} from "@/support/reactive"

/**
 * @status stable
 * @published 4.0.0
 * @changelog 4.0.0 Published.
 */
@Component
export default class JdsToolbar extends Vue {
    @ActiveProvide('jds.button.size') buttonSize: string = 'medium';
    @Prop() size!: string;
    @Prop({default: false, type: Boolean}) centered!: boolean;
    @Prop({default: false, type: Boolean}) right!: boolean;

    @Watch('size', {immediate: true})
    syncSize (size: string) {
        this.buttonSize = size;
    }
}
